// BTCheckBox
import { Checkbox, FormControlLabel } from '@mui/material';
import { TitleNormal } from '../common-text';
import BTBox from './BTBox';
import theme from '../theme';
import { HorizontalLayout } from '../common-layout';

interface BTCheckBoxProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label?: string;
    title?: string;
    disabled?: boolean;
    readOnly?: boolean;
    sx?: object;
}

export const BTCheckBox: React.FC<BTCheckBoxProps> = (props) => {
  const { checked, onChange, label, title, disabled=false, readOnly=false, sx={} } = props;

  return (
    <div style={{ display:'flex', alignItems:'center' }}>
      {title && (
        <div style={{ display:'inline-flex', alignItems:'center' }}>
          <TitleNormal color="#8a92a6">{title}</TitleNormal>
          <BTBox width="16px" />
        </div>
      )}

      <FormControlLabel
        sx={{
          m: 0,
          alignItems: 'center',
          '.MuiFormControlLabel-label': { display:'flex', alignItems:'center' },
        }}
        control={
          <Checkbox
            checked={checked}
            onChange={readOnly ? () => {} : onChange}
            disabled={disabled || readOnly}
            sx={{
              p: 0, // ⬅️ 패딩 제거로 정렬 안정화
              color: theme.colors.bbTech,
              '&.Mui-checked': { color: theme.colors.bbTech },
              ...sx,
            }}
          />
        }
        label={label ? <TitleNormal color="#000">{label}</TitleNormal> : null}
      />
    </div>
  );
};